export const LINKS = {
  website: 'https://www.sixt.jobs/en/jobs?level=&field=&country=IN&location=#job-results',
  jobsRelativeUrl: 'https://www.sixt.jobs/fr/job/',
  jobsAPI: 'https://api.sixt.jobs/jobs',
};
